import { render, staticRenderFns } from "./YoutubeEmbed.vue?vue&type=template&id=450042e6"
import script from "./YoutubeEmbed.vue?vue&type=script&lang=js"
export * from "./YoutubeEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('450042e6')) {
      api.createRecord('450042e6', component.options)
    } else {
      api.reload('450042e6', component.options)
    }
    module.hot.accept("./YoutubeEmbed.vue?vue&type=template&id=450042e6", function () {
      api.rerender('450042e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/content/YoutubeEmbed.vue"
export default component.exports